<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Profil bearbeiten</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProducerForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <!-- company logo -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <vue-dropzone
                        name="companyLogo"
                        ref="uploadCompanyLogo"
                        id="example-input-0 dropzone"
                        :useCustomSlot="true"
                        :options="logoDropzoneOptions"
                        @vdropzone-file-added="
                          (file) => uploadCompanyLogo(file)
                        "
                        @vdropzone-removed-file="handleRemoveLogo"
                        aria-describedby="input-0-live-feedback"
                      >
                        <div
                          class="dropzone dropzone-default"
                          id="kt_dropzone_1"
                        >
                          <div class="dropzone-msg dz-message needsclick">
                            <h4>Bitte laden sie ein Firmenlogo hoch</h4>
                            <h5>
                              Datei hierhin ziehen oder klicken zum Upload
                            </h5>
                            <p>
                              Erlaubte Formate: JPEG, PNG
                              <br />Maximale Upload-Größe: 1MB
                            </p>
                          </div>
                        </div>
                      </vue-dropzone>
                    </b-form-group>
                  </div>
                </div>
                <!-- end company logo -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Vorname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.firstName"
                          :error-messages="errors[0]"
                          label="Vorname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Nachname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.lastName"
                          :error-messages="errors[0]"
                          label="Nachname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die E-Mail ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.email"
                          :error-messages="errors[0]"
                          label="E-Mail"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="phone"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Telefonnummer ist erforderlich',
                        }"
                      >
                        <vue-tel-input
                          :class="errors[0] ? 'error-outline' : ''"
                          v-on:country-changed="countryChanged"
                          :validCharactersOnly="true"
                          :onlyCountries="countryArr"
                          :defaultCountry="form.phoneCountry"
                          :enabledCountryCode="false"
                          mode="international"
                          v-model="form.phone"
                          placeholder="Telefonnummer"
                        ></vue-tel-input>
                        <span class="form-errors">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules=""
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'UID Nummer ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        v-model="form.uid"
                        label="UID Nummer"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- company anme -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Markenname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.brandName"
                          :error-messages="errors[0]"
                          label="Markenname"
                          outlined
                        ></v-text-field>
                        {{ errors[0] }}
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Firmenname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.companyName"
                          :error-messages="errors[0]"
                          label="Firmenname"
                          outlined
                        ></v-text-field>
                        {{ errors[0] }}
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="urlInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Firmen-Webseite ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.website"
                          :error-messages="errors[0]"
                          label="Firmen-Webseite"
                          placeholder="zum Beispiel https://www.meinefirma.at"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <!-- end company anme -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Firmenbeschreibung ist erforderlich',
                        }"
                      >
                        <!-- <vue-editor
                          placeholder="Firmenbeschreibung"
                          :class="errors[0] ? 'error-outline' : ''"
                          v-model="form.companyDescription"
                        ></vue-editor> -->
                        <ckeditor
                          v-model="form.companyDescription"
                          :config="editorConfig"
                        ></ckeditor>
                        <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <!-- company images -->
                <b-form-group id="fieldset-horizontal">
                  <span>Sie können noch weitere Bilder hochladen</span>
                  <vue-dropzone
                    name="companyPictures"
                    ref="uploadProducerImages"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte laden sie Bilder zum Unternehmen hoch</h4>
                        <h5>Dateien hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Allowed format: JPEG, PNG
                          <br />Maximum upload size: 1MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>
                <!-- end company images -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Category is required.',
                        }"
                      >
                        <v-combobox
                          v-model="form.producerCategories"
                          :items="categories"
                          :error-messages="errors[0]"
                          label="Kategorie"
                          item-text="category_name"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Address is required.',
                    }"
                  >
                    <VueGooglePlaces
                      :api-key="googleApiKey"
                      :enable-geolocation="false"
                      @placechanged="onPlaceChanged"
                      types="address"
                    >
                      <v-text-field
                        autocomplete="new-password"
                        v-model="form.providerAddress"
                        :error-messages="errors[0]"
                        placeholder="Adresse"
                        outlined
                      ></v-text-field>
                    </VueGooglePlaces>
                  </ValidationProvider>
                </b-form-group>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Country"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Land ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="countries"
                          v-model="form.country"
                          :error-messages="errors[0]"
                          item-text="value"
                          item-value="value"
                          label="Land"
                          outlined
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Bundesland ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="statesList"
                          v-model="form.state"
                          :error-messages="errors[0]"
                          item-text="name"
                          item-value="id"
                          label="Bundesland"
                          outlined
                          clearable
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="City"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Stadt ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.city"
                          :error-messages="errors[0]"
                          label="Stadt"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Postal Code"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'die Postleitzahl ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.postCode"
                          :error-messages="errors[0]"
                          label="Postleitzahl"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <h5>Zahlungsanbieter Details</h5>
                <span><b>1. Stripe</b></span>
                <div class="row my-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.stripePublicKey"
                        label="Stripe öffentlicher Schlüssel (Public Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.stripeSecretKey"
                        label="Stripe geheimer Schlüssel (Secret Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>2. PayPal</b></span>
                <div class="row my-3">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalEmail"
                        label="Paypal Anmelde-Adresse"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalClientId"
                        label="PayPal Client ID"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.paypalSecretKey"
                        label="PaypPal geheimer Schlüssel (Secret Key)"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div> -->
                </div>

                <span><b>3. Mollie</b></span>
                <div class="row my-3">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.mollieKey"
                        label="Mollie Schlüssel (Key)"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>4. Klarna</b></span>
                <div class="row my-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.klarnaUsername"
                        label="Klarna API Benutzername"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.klarnaPassword"
                        label="Klarna API Passwort"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>

                <span><b>5. Sumup</b></span>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.sumupClientId"
                        label="SumUp Client ID"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      > -->
                      <v-text-field
                        type="text"
                        autocomplete="new-password"
                        v-model="form.sumupClientSecret"
                        label="SumUp Client Secret"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="email"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.sumupEmail"
                          :error-messages="errors[0]"
                          label="SumUp E-Mail"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <!-- social media links -->
                <v-divider></v-divider>
                <div
                  class="row"
                  v-for="(sinfo, i) in form.socialMediaInfo"
                  :key="'L' + i"
                >
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="socialMedias"
                        v-model="sinfo.name"
                        item-text="name"
                        item-value="name"
                        label="Social Media"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="urlInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="sinfo.link"
                          :error-messages="errors[0]"
                          label="Social Media Link"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeSocialSites(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addSocialSites"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <!-- end social media links -->
                <v-divider></v-divider>
                <!-- weekdays time slot -->
                <!-- <div
                  class="row"
                  v-for="(winfo, i) in form.weekDaysTimeInfo"
                  :key="'W' + i"
                >
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="weekDays"
                        v-model="winfo.name"
                        item-text="label"
                        item-value="name"
                        label="Wochentag wählen"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <vue-timepicker
                      v-model="winfo.from_time"
                      placeholder="Zeit ab"
                      format="hh:mm A"
                    ></vue-timepicker>
                  </div>
                  <div class="col-md-3">
                    <vue-timepicker
                      v-model="winfo.to_time"
                      placeholder="Zeit bis"
                      format="hh:mm A"
                    ></vue-timepicker>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeDayHour(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addDayHour"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div> -->
                <!-- end weekdays time slot -->
                <b-form-group class="mt-5"> </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="providers" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
// import { VueEditor, Quill } from "vue2-editor";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import config from "@/config/app";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
//import Loader from "@/components/admin/layout/Loader.vue";
import { VueGooglePlaces } from "vue-google-places";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import VueTelInput from "vue-tel-input";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import { LOGIN, UPDATE_USER } from "@/core/services/store/auth.module";
import { alpha } from "vee-validate";
import providerAPI from "@/api/provider";
Vue.use(Croppa, { componentName: "my-image-cropper" });

import { extend } from "vee-validate";
import CKEditor from "ckeditor4-vue";

Vue.use(CKEditor);

extend("urlInput", {
  message: (field) =>
    "Bitte geben sie eine gültige URL ein, die mit http:// oder https:// beginnt",
  validate: (value) => {
    var regx =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    var validUrl = regx.test(value);
    if (validUrl) {
      return true;
    } else {
      false;
    }
  },
});

Vue.use(VueTelInput);
Vue.use(Notifications);
export default {
  name: "EditProfile",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.form.country = this.currentUser.country_code;
      this.form.phone = this.currentUser.mobile_no;
      this.getProviderData(true);
      this.getCategories();
      this.getStates();
      setTimeout(() => {
        this.isLoadPhone = true;
      }, 1000);
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    // VueEditor,
    VueGooglePlaces,
    // VueTimepicker,
  },
  data() {
    return {
      countries: [{ value: "Österreich" }, { value: "Deutschland" }],
      googleApiKey: config.GOOGLE_PLACE_API_KEY,
      dropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 10,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
      },
      countryArr: config.availableCountries,
      logoDropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: false,
        uploadprogress: false,
      },
      formError: false,
      isLoading: false,
      pdfFileString: null,
      formData: [],
      pdfFileTest: "",
      btnDisable: false,
      initialProfilePicture: null,
      submitText: "Speichern",
      countryDialCode: "43",
      isLoadPhone: false,
      editorConfig: {
        language: 'de',scayt_sLang : 'de_DE'
      },
      imageChanged: "0",
      currentImage: null,
      acceptImageLength: 4,
      oldImages: [],
      categories: [],
      statesList: [],
      old_email: "",
      old_company_name: "",
      isEmailVerified: false,
      form: {
        logo: "",
        producerImages: [],
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        providerAddress: "",
        companyName: "",
        brandName: "",
        companyDescription: "",
        website: "",
        country: "",
        state: "",
        city: "",
        postCode: "",
        phoneCountry: "AT",
        status: "",
        companyLatitude: "",
        companyLongitude: "",
        socialMediaInfo: [],
        weekDaysTimeInfo: [],
        producerCategories: [],
        uid: "",
        stripePublicKey: "",
        stripeSecretKey: "",
        paypalEmail: "",
        // paypalClientId: "",
        // paypalSecretKey: "",
        mollieKey: "",
        klarnaUsername: "",
        klarnaPassword: "",
        sumupClientId: "",
        sumupClientSecret: "",
        sumupEmail: "",
      },

      weekDays: [
        {
          name: "Sunday",
          label: "So",
        },
        {
          name: "Monday",
          label: "Mo",
        },
        {
          name: "Tuesday",
          label: "Di",
        },
        {
          name: "Wednesday",
          label: "Mi",
        },
        {
          name: "Thursday",
          label: "Do",
        },
        {
          name: "Friday",
          label: "Fr",
        },
        {
          name: "Saturday",
          label: "Sa",
        },
      ],
      socialMedias: [
        {
          name: "Facebook",
        },
        {
          name: "Twitter",
        },
        {
          name: "LinkedIn",
        },
        {
          name: "Instagram",
        },
        {
          name: "XING",
        },
        {
          name: "Pinterest",
        },
        {
          name: "Reddit",
        },
        {
          name: "Tumblr",
        },
      ],
    };
  },
  watch: {
    // "form.phone": function (value) {
    //   if (value[0] == 0 && this.isLoadPhone) {
    //     this.form.phone = value.substring(1);
    //   }
    // },
  },
  methods: {
    handleVerifyEmail() {
      providerAPI
        .handleVerifyEmail({ producer_id: this.currentUser.id })
        .then((response) => {
          if (response.status == "success") {
            window.open(response.link, "_blank");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToBack() {
      this.$router.push({ name: "producer-dashboard" });
    },
    countryChanged(country) {
      this.countryDialCode = country.dialCode;
      this.form.phoneCountry = country.iso2;
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.producerImages.push(file);
        }
      }, 500);
    },

    handleRemoveImage(file) {
      var array = this.oldImages.filter((elm) => elm.photo_name !== file.name);
      this.oldImages = array;
    },

    handleRemoveLogo() {
      this.form.logo = null;
      this.currentImage = null;
    },
    uploadCompanyLogo(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.imageChanged = "1";
          this.form.logo = file;
        }
      }, 1000);
    },

    addSocialSites() {
      this.form.socialMediaInfo.push({
        name: "",
        link: "",
      });
    },
    removeSocialSites(i) {
      this.form.socialMediaInfo.splice(i, 1);
    },

    // addDayHour() {
    //   this.form.weekDaysTimeInfo.push({
    //     name: "",
    //     from_time: "",
    //     to_time: "",
    //   });
    // },
    // removeDayHour(i) {
    //   this.form.weekDaysTimeInfo.splice(i, 1);
    // },
    onPlaceChanged(e) {
      this.form.providerAddress = e.name;
      this.form.companyLatitude = e.latitude;
      this.form.companyLongitude = e.longitude;
      this.form.country = e.country;
      this.form.city = e.locality;
      this.form.postCode = e.postal_code;
    },
    getStates() {
      providerAPI
        .getStates()
        .then((response) => {
          if (response.status == "success") {
            this.statesList = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getCategories() {
      providerAPI
        .activeCategory()
        .then((response) => {
          if (response.status == "success") {
            this.categories = response.data;
          } else {
            this.$notify({
              group: "providers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "providers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getProviderData(reload = true) {
      axios
        .post("producer/edit-producer", { id: this.$route.params.id })
        .then((response) => {
          var responseJson = response.data.data;
          // console.log(response.data);
          if (response.data.status == "success") {
            if (response.data) {
              let data = {
                id: responseJson.user_id,
                first_name: responseJson.user_detail.first_name,
                last_name: responseJson.user_detail.last_name,
                email: responseJson.user_detail.email,
                mobile_no: responseJson.user_detail.mobile_no,
                address: responseJson.address,
                country: responseJson.country,
                city: responseJson.city,
                postcode: responseJson.postcode,
                delivery_address: responseJson.delivery_address
                  ? responseJson.delivery_address
                  : "",
                delivery_city: responseJson.delivery_city
                  ? responseJson.delivery_city
                  : "",
                delivery_country: responseJson.delivery_country
                  ? responseJson.delivery_country
                  : "",
                delivery_postcode: responseJson.delivery_postcode
                  ? responseJson.delivery_postcode
                  : "",
                role: "producer",
                profile_photo_path: responseJson.user_detail.profile_photo_path,
              };
              this.$store.dispatch(UPDATE_USER, data);

              if (reload) {
                this.form.firstName = responseJson.user_detail.first_name;
                this.form.lastName = responseJson.user_detail.last_name;
                this.form.email = responseJson.user_detail.email;
                this.old_email = responseJson.user_detail.email;
                this.form.companyName = responseJson.company_name;
                this.old_company_name = responseJson.company_name;
                /*this.isEmailVerified =
                  responseJson.payment_details.is_paypal_verified == "1"
                    ? true
                    : false
                    ? responseJson.company_name
                    : "";*/
                this.form.brandName = responseJson.brand_name
                  ? responseJson.brand_name
                  : "";
                this.form.companyDescription = responseJson.description
                  ? responseJson.description
                  : "";
                this.form.website = responseJson.website
                  ? responseJson.website
                  : "";
                this.form.providerAddress = responseJson.address
                  ? responseJson.address
                  : "";
                this.form.country = responseJson.country
                  ? responseJson.country
                  : "";
                this.form.state = responseJson.state_id
                  ? responseJson.state_id
                  : "";
                this.form.city = responseJson.city ? responseJson.city : "";
                this.form.postCode = responseJson.postcode
                  ? responseJson.postcode
                  : "";
                this.form.companyLatitude = responseJson.company_latitude
                  ? responseJson.company_latitude
                  : "";
                this.form.companyLatitude = responseJson.company_longitude
                  ? responseJson.company_longitude
                  : "";

                this.form.uid = responseJson.uid ? responseJson.uid : "";
                this.form.phone = responseJson.user_detail.mobile_no;

                if (responseJson.payment_details) {
                  this.form.stripePublicKey = responseJson.payment_details
                    .stripe_public_key
                    ? responseJson.payment_details.stripe_public_key
                    : "";
                  this.form.stripeSecretKey = responseJson.payment_details
                    .stripe_secret_key
                    ? responseJson.payment_details.stripe_secret_key
                    : "";
                  // this.form.paypalClientId = responseJson.payment_details
                  //   .paypal_client_id
                  //   ? responseJson.payment_details.paypal_client_id
                  //   : "";
                  this.form.paypalEmail = responseJson.payment_details
                    .paypal_email
                    ? responseJson.payment_details.paypal_email
                    : "";
                  // this.form.paypalSecretKey = responseJson.payment_details
                  //   .paypal_secret
                  //   ? responseJson.payment_details.paypal_secret
                  //   : "";
                  this.form.mollieKey = responseJson.payment_details.mollie_key
                    ? responseJson.payment_details.mollie_key
                    : "";
                  this.form.klarnaUsername = responseJson.payment_details
                    .klarna_api_username
                    ? responseJson.payment_details.klarna_api_username
                    : "";
                  this.form.klarnaPassword = responseJson.payment_details
                    .klarna_api_password
                    ? responseJson.payment_details.klarna_api_password
                    : "";
                  this.form.sumupClientId = responseJson.payment_details
                    .sumup_client_id
                    ? responseJson.payment_details.sumup_client_id
                    : "";
                  this.form.sumupClientSecret = responseJson.payment_details
                    .sumup_client_secret
                    ? responseJson.payment_details.sumup_client_secret
                    : "";
                  this.form.sumupEmail = responseJson.payment_details
                    .sumup_email
                    ? responseJson.payment_details.sumup_email
                    : "";
                }

                if (responseJson.social_links.length) {
                  responseJson.social_links.forEach((item) => {
                    this.form.socialMediaInfo.push({
                      name: item.name,
                      link: item.link,
                    });
                  });
                } else {
                  this.form.socialMediaInfo.push({
                    name: "",
                    link: "",
                  });
                }

                // if (responseJson.working_time.length) {
                //   responseJson.working_time.forEach((item) => {
                //     this.form.weekDaysTimeInfo.push({
                //       name: item.name,
                //       from_time: item.from_time,
                //       to_time: item.to_time,
                //     });
                //   });
                // } else {
                //   this.form.weekDaysTimeInfo.push({
                //     name: "",
                //     from_time: "",
                //     to_time: "",
                //   });
                // }

                if (responseJson.categories.length) {
                  responseJson.categories.forEach((item) => {
                    if (item.category_detail) {
                      this.form.producerCategories.push({
                        category_name: item.category_detail.category_name,
                        id: item.category_id,
                      });
                    }
                  });
                }

                if (responseJson.pictures.length) {
                  this.acceptImageLength = 4 - responseJson.pictures.length;
                  this.oldImages = responseJson.pictures;
                  responseJson.pictures.forEach((item, i) => {
                    if (
                      item.photo_path.indexOf(".jpg") !== -1 ||
                      item.photo_path.indexOf(".jpeg") !== -1
                    ) {
                      var file = {
                        size: 12345,
                        name: item.photo_name,
                        type: "image/jpeg",
                      };
                      this.$refs.uploadProducerImages.manuallyAddFile(
                        file,
                        item.photo_path
                      );
                    }
                    if (item.photo_path.indexOf(".png") !== -1) {
                      var file = {
                        size: 12345,
                        name: item.photo_name,
                        type: "image/png",
                      };
                      this.$refs.uploadProducerImages.manuallyAddFile(
                        file,
                        item.photo_path
                      );
                    }
                  });
                }
                // LOGO IMAGE
                this.form.logo = responseJson.logo_path;
                this.currentImage = responseJson.logo_path;
                if (responseJson.logo_path) {
                  if (
                    responseJson.logo_path.indexOf(".jpg") !== -1 ||
                    responseJson.logo_path.indexOf(".jpeg") !== -1
                  ) {
                    var file = {
                      size: 12345,
                      name: responseJson.logo_path,
                      type: "image/jpeg",
                    };
                    this.$refs.uploadCompanyLogo.manuallyAddFile(
                      file,
                      responseJson.logo_path
                    );
                  }
                  if (responseJson.logo_path.indexOf(".png") !== -1) {
                    var file = {
                      size: 12345,
                      name: responseJson.logo_path,
                      type: "image/png",
                    };
                    this.$refs.uploadCompanyLogo.manuallyAddFile(
                      file,
                      responseJson.logo_path
                    );
                  }
                }
              }
              localStorage.setItem(
                "bar_book_a_room_user_profile_picture",
                responseJson.logo_path
              );
            }
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "providers",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "providers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    onSubmit() {
      this.$refs.newProducerForm.validate().then((success) => {
        if (success) {
          if (this.form.logo !== null) {
            this.formError = false;
            this.btnDisable = true;
            this.submitText = "Wird gespeichert...";
            localStorage.setItem("currentProviderCountry", this.form.country);

            //-----country code
          const germanyPattern = /^(\+|00)49/;
          const austriaPattern = /^(\+|00)43/;

          // Check if the phone number matches either pattern
          const isGermanNumber = germanyPattern.test(this.form.phone);
          const isAustrianNumber = austriaPattern.test(this.form.phone);

          if (isGermanNumber) {
            console.log('+49 (Germany)');
          } else if (isAustrianNumber) {
            console.log('+43 (Austria)');
          } else {
            var phoneNumber = this.form.phone
            this.form.phone = '+'+this.countryDialCode+' '+phoneNumber
          }

          //-----------

            let formData = new FormData();
            formData.append("user_id",  this.currentUser.id);
            formData.append("id", this.$route.params.id);
            formData.append("first_name", this.form.firstName);
            formData.append("last_name", this.form.lastName);
            formData.append("email", this.form.email);
            formData.append("old_email", this.old_email);
            formData.append("address", this.form.providerAddress);
            formData.append("uid", this.form.uid);
            formData.append("city", this.form.city);
            formData.append("country", this.form.country);
            formData.append("state_id", this.form.state);
            formData.append("postcode", this.form.postCode);
            formData.append("stripe_public_key", this.form.stripePublicKey);
            formData.append("stripe_secret_key", this.form.stripeSecretKey);
            formData.append("paypal_email", this.form.paypalEmail);
            // formData.append("paypal_client_id", this.form.paypalClientId);
            // formData.append("paypal_secret", this.form.paypalSecretKey);
            formData.append("mollie_key", this.form.mollieKey);
            formData.append("klarna_api_username", this.form.klarnaUsername);
            formData.append("klarna_api_password", this.form.klarnaPassword);
            formData.append("sumup_client_id", this.form.sumupClientId);
            formData.append("sumup_client_secret", this.form.sumupClientSecret);
            formData.append("sumup_email", this.form.sumupEmail);
            formData.append("country_dial_code", "+" + this.countryDialCode);
            formData.append("country_code", this.form.phoneCountry);
            formData.append("phone", this.form.phone);
            formData.append("brand_name", this.form.brandName);
            formData.append("company_name", this.form.companyName);
            formData.append("old_company_name", this.old_company_name);
            formData.append(
              "company_description",
              this.form.companyDescription
            );
            formData.append("website", this.form.website);
            formData.append(
              "social_informations",
              JSON.stringify(this.form.socialMediaInfo)
            );
            // formData.append(
            //   "weekdays_informations",
            //   JSON.stringify(this.form.weekDaysTimeInfo)
            // );
            const categories = [];
            for (var i = 0; i < this.form.producerCategories.length; i++) {
              categories.push(this.form.producerCategories[i].id);
            }
            formData.append("producer_categories", JSON.stringify(categories));

            formData.append("company_latitude", this.form.companyLatitude);
            formData.append("company_longitude", this.form.companyLongitude);

            //formData.append("image_changed", this.imageChanged);
            for (var i = 0; i < this.form.producerImages.length; i++) {
              formData.append("file[" + i + "]", this.form.producerImages[i]);
            }
            var oldFiles = [];
            for (var i = 0; i < this.oldImages.length; i++) {
              oldFiles.push(this.oldImages[i].photo_name);
            }
            formData.append("old_file", oldFiles);
            // COMPANY LOGO
            formData.append("image_changed", this.imageChanged);
            formData.append("company_logo", this.form.logo);

            setTimeout(() => {
              axios
                .request({
                  method: "POST",
                  url: "producer/update-producer",
                  mimeType: "multipart/form-data",
                  data: formData,
                })
                .then((response) => {
                  if (response.data.status == "success") {
                    this.getProviderData(false);
                    this.old_email = this.form.email;
                    this.$notify({
                      group: "providers",
                      type: "success",
                      position: "bottom right",
                      text: response.data.msg,
                      duration: 5000,
                    });
                    this.btnDisable = false;
                    this.submitText = "Speichern";
                    setTimeout(() => {
                     this.$router.push({name: "producer-dashboard"});
                   }, 3000);
                  } else {
                    this.btnDisable = false;
                    this.submitText = "Speichern";
                    this.$notify({
                      group: "providers",
                      type: "error",
                      position: "bottom right",
                      text: response.data.msg,
                      duration: 5000,
                    });
                  }
                })
                .catch((err) => {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "providers",
                    type: "error",
                    position: "bottom right",
                    text: err,
                    duration: 5000,
                  });
                });
            }, 2000);
          } else {
            this.$notify({
              group: "providers",
              type: "error",
              position: "bottom right",
              text: "Das Firmenlogo ist erforderlich",
              duration: 5000,
            });
          }
        } else {
          this.$notify({  
            group: "providers",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.croppa-container svg.icon-remove {
  top: 0 !important;
  right: unset !important;
  left: 0 !important;
}

.profile-initial-pic {
  position: relative;
}

.remove-btn {
  position: absolute;
  top: -5px;
  cursor: pointer;
}
</style>
